import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Flex/Flex.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Grid/Grid.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/GridColumn/GridColumn.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Icon/Icon.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/molecules/Footer/FooterMenu/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/molecules/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/molecules/NotFoundMessage/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/organisms/PageBody/PageBody.module.scss");
